export const IconHamburger = (props) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M29.5 8.00001C27.2854 8.00001 25.1387 8.29486 22.9194 8.29486C21.8334 8.29486 20.6659 8.2967 19.6291 8.48596C19.1107 8.58059 18.5367 8.41782 18.0138 8.51326C17.4062 8.62417 16.7213 8.78627 16.0995 8.78627C15.0439 8.78627 13.9525 8.88455 12.9288 8.88455C8.96345 8.88455 5.46952 8.29486 1.5 8.29486"
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M1.5 16.0811C7.50915 16.0811 13.4868 15.8846 19.4971 15.8846C20.9005 15.8846 22.2609 15.9828 23.6642 15.9828C24.6507 15.9828 25.6371 15.9828 26.6235 15.9828C26.967 15.9828 27.2523 16.1794 27.5965 16.1794C28.1268 16.1794 28.9919 16.1794 29.5 16.1794"
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M1.5 23.2777C3.84261 23.2777 6.09861 23.2747 8.41297 23.5507C9.20039 23.6446 9.97694 23.6708 10.7727 23.6708C13.4332 23.6708 16.1032 23.5725 18.7758 23.5725C20.9341 23.5725 23.0165 23.1794 25.1636 23.1794C26.6222 23.1794 28.0496 23.2419 29.5 23.2419"
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)
